import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import apiClient from "../../api-services/ApiClient";
import Preloader from "../../app-components/preloader/Preloader";
import { errorAlert } from "../../app-util/SweetAlert";
import { ELITELINKS, SITELINKS } from "../../app-routes/links";
import { storeToken, storeUser } from "../../api-services/process";

const LinkedInCallback = () => {
  const navigate = useNavigate();

  const LinkedInLogin = async (code: any, state: any) => {
    sessionStorage.setItem("linkedinCallbackCalled", "true");

    try {
      const res = await apiClient.post("/login-with-linkedin", {
        code,
        state,
      });

      const user = res.data?.data?.user;
      storeToken(res.data?.data?.token);
      storeUser(user);

      if (!user?.username || !user?.DOB) navigate(SITELINKS.REGISTER_STEP_TWO);
      else navigate(ELITELINKS.ELITE);
    } catch (error: any) {
      sessionStorage.removeItem("linkedinCallbackCalled");
      errorAlert();
      navigate(SITELINKS.LOGIN);
    }
  };

  useEffect(() => {
    const alreadyCalled = sessionStorage.getItem("linkedinCallbackCalled");
    if (alreadyCalled) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state") ?? "";

    if (code && state) LinkedInLogin(code, state);
    else {
      errorAlert();
      navigate(SITELINKS.LOGIN);
    }

    // eslint-disable-next-line
  }, [navigate]);

  return <Preloader loading={true} />;
};

export default LinkedInCallback;
